import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { IWizItemRenderer, WizBaseCollector, WizEventManager, WizRoot } from '@wizeoo/akm-component-lib';
import { ALK_EVENT_TYPE} from '../../../model/enums';

/**
 * rendu des champs disponibles
 */
@Component({
  selector: 'timeline-event-renderer',
  templateUrl: './timeline-event.renderer.html',
})
export class TimelineEventRenderer implements IWizItemRenderer<null, any> {
  
  constructor(public elementRef: ElementRef) {
  }
  private _data: any;
  public get data(): any {
    return this._data;
  }
  public set data(value: any) {
    this._data = value;
  }

  owner: WizBaseCollector;

  public get color(): string {
    return this.data.extendedProps.color;
  }

  public get titleStr(): string {
    return this.data.extendedProps.title;
  }

  public get fullStr(): string {
    return this.data.extendedProps.title + ' - ' + this.data.extendedProps.content;
  }

  public get contentStr(): string {
    return this.data.extendedProps.content;
  }

}
